import {DateUtil} from "base/utilities";
import {
    ChipCardDivider,
    SectionCard,
    SectionField,
} from "base/component/presentational";

const formatUserRole = userInfo => {
    if (!userInfo) return "";
    const role =
        userInfo.role ||
        (userInfo.roles && userInfo.roles.length > 0 ? userInfo.roles[0] : "");
    if (!role) return "";
    if (role.toLowerCase() === "concello" && userInfo.concello) {
        return `${role} (${userInfo.concello})`;
    }
    return role;
};

const EntityAuditSection = ({entity}) => {
    const createdByInfo = entity?.created_by_info;
    const updatedByInfo = entity?.updated_by_info;
    const lastChange = entity?.last_change;

    const createdRoleLabel = formatUserRole(createdByInfo);
    const updatedRoleLabel = formatUserRole(updatedByInfo);
    const changeRoleLabel = formatUserRole(lastChange?.user);
    const resolutionRoleLabel = formatUserRole(lastChange?.resolution_user);
    const isApproved = lastChange?.action_state === "APPROVED";
    const isRejected = lastChange?.action_state === "REJECTED";

    return (
        <SectionCard title="Datos de auditoría">
            <SectionField
                label="Fecha de creación:"
                value={DateUtil.formatDate(entity.created_at)}
            />
            <SectionField label="Creado por:" value={entity.created_by} />
            {createdRoleLabel && (
                <SectionField
                    label="Tipo de usuario (creación):"
                    value={createdRoleLabel}
                />
            )}
            {createdByInfo?.concello &&
                (!createdRoleLabel ||
                    !createdRoleLabel.includes(createdByInfo.concello)) && (
                    <SectionField
                        label="Concello asociado (creación):"
                        value={createdByInfo.concello}
                    />
                )}

            <SectionField
                label="Fecha de actualización de la entidad:"
                value={DateUtil.formatDate(entity.updated_at)}
            />
            {updatedByInfo?.concello &&
                (!updatedRoleLabel ||
                    !updatedRoleLabel.includes(updatedByInfo.concello)) && (
                    <SectionField
                        label="Concello asociado (actualización):"
                        value={updatedByInfo.concello}
                    />
                )}

            {lastChange && (
                <>
                    <ChipCardDivider label="Último cambio rexistrado" />
                    {lastChange.summary && (
                        <SectionField
                            label="Detalle do cambio:"
                            value={lastChange.summary}
                        />
                    )}
                    {lastChange.action_date && (
                        <SectionField
                            label="Data do cambio:"
                            value={DateUtil.formatDateTime(lastChange.action_date)}
                        />
                    )}
                    {lastChange.user?.username && (
                        <SectionField
                            label="Cambio realizado por:"
                            value={lastChange.user.username}
                        />
                    )}
                    {changeRoleLabel && (
                        <SectionField
                            label="Tipo de usuario que realizou o cambio:"
                            value={changeRoleLabel}
                        />
                    )}
                    {lastChange.resolution_user?.username && (
                        <SectionField
                            label={
                                isApproved
                                    ? "Cambio aprobado por:"
                                    : isRejected
                                    ? "Cambio rexeitado por:"
                                    : "Cambio resolto por:"
                            }
                            value={lastChange.resolution_user.username}
                        />
                    )}
                    {resolutionRoleLabel && (
                        <SectionField
                            label={
                                isApproved
                                    ? "Tipo de usuario que aprobou o cambio:"
                                    : isRejected
                                    ? "Tipo de usuario que rexeitou o cambio:"
                                    : "Tipo de usuario que resolveu o cambio:"
                            }
                            value={resolutionRoleLabel}
                        />
                    )}
                    {lastChange.resolution_date && (
                        <SectionField
                            label={
                                isApproved
                                    ? "Data de aprobación:"
                                    : isRejected
                                    ? "Data de rexeitamento:"
                                    : "Data de resolución:"
                            }
                            value={DateUtil.formatDateTime(lastChange.resolution_date)}
                        />
                    )}
                    {lastChange.entity_type && (
                        <SectionField
                            label="Entidade modificada:"
                            value={
                                lastChange.entity_name
                                    ? `${lastChange.entity_type.toUpperCase()} - ${
                                          lastChange.entity_name
                                      }`
                                    : lastChange.entity_type.toUpperCase()
                            }
                        />
                    )}
                    {lastChange.concello && (
                        <SectionField
                            label="Concello do cambio:"
                            value={lastChange.concello}
                        />
                    )}
                    {lastChange.action_type && (
                        <SectionField
                            label="Tipo de acción:"
                            value={lastChange.action_type}
                        />
                    )}
                    {lastChange.action_state && (
                        <SectionField
                            label="Estado da acción:"
                            value={lastChange.action_state}
                        />
                    )}
                </>
            )}
        </SectionCard>
    );
};

export default EntityAuditSection;
